import { onConnect } from '@reatom/framework'

import { reatomRequest } from '@root/shared/lib'

import { getTiktokPostOembedRequestAction } from './get-tiktok-post-oembed-request-action'

import type * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

export const tiktokPostOembed = (options: {
  resource: KnownSocialPlatformResource.TiktokKnownSocialPlatformResource<'tiktok'>
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestModel = reatomRequest({
    execAction: getTiktokPostOembedRequestAction,
    prepare: () => ({ resource: options.resource }),
  })

  onConnect(requestModel, (ctx) => {
    requestModel.execute(ctx)
  })

  return { requestModel }
}
